import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import { PolatliBlog } from './pages/PolatliBlog';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render( 
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/hizmetlerimiz" element={<Services />} />
      <Route path="/hakkimizda" element={<About />} />
      <Route path="/iletisim" element={<Contact />} />
      <Route path="/polatli-personel-tasimacilik" element={<PolatliBlog />} />
    </Routes>
  </BrowserRouter>
  
);

